var _defs, _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonhide01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-34,.cls-33,.cls-32,.cls-31{fill:#fff;}.cls-33,.cls-32,.cls-31{stroke:#000;stroke-miterlimit:10;}.cls-33{stroke-width:2.99px;}.cls-32{stroke-width:0.95px;stroke-dasharray:3.74;}.cls-31{stroke-width:1.03px;stroke-dasharray:4.03;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 147.81,
    y: 106.33,
    width: 133.18,
    height: 278.17
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 147.81,
    y1: 384.9,
    x2: 147.81,
    y2: 106.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 280.99,
    y1: 106.33,
    x2: 280.99,
    y2: 384.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 151.14,
    y1: 384.9,
    x2: 151.14,
    y2: 106.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 277.66,
    y1: 106.33,
    x2: 277.66,
    y2: 387.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonhide01);
export default __webpack_public_path__ + "static/media/BUTTON HIDE-01.0ea240ad790f5ff68356d7e66c141b21.svg";
export { ForwardRef as ReactComponent };